import React, { useEffect } from 'react';

import { useAxios } from '../../../AxiosHandler';

import { useTranslate } from 'react-polyglot';
import { useParams } from 'react-router-dom';

import styles from './BreedingDogs.module.scss';
import PublicTable from '../../Shared/PublicTable/PublicTable';
import Card from '../../Shared/Card/Card';
import { Form } from 'react-bootstrap';

/*

Table Columns:

REG.NR.
NAVN
BILDE
ALDER
HD-INDEX
HD
KULL
VALPER
% Jaktpremierte avkom
TITTEL JAKT
RESULTAT UTSTILLING
KULLVERDI
JAKT-INDEX
moment 1
moment 3
moment 5
moment 9
AVLSGRANSKING
GLAUKOM	DVERGVEKST
EIER
POSTNR.
STED
E-POST
TLF.
MOBIL

*/

function BreedingDogs(props: BreedingDogsProps) {
    const t = useTranslate();
    const params = useParams();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [loading, setLoading] = React.useState(true);

    const [dogs, setDogs] = React.useState<any>([]);
    const [filteredDogs, setFilteredDogs] = React.useState<any>([]);

    const [sexFilter, setSexFilter] = React.useState("both");
    const [publishTypeFilter, setPublishTypeFilter] = React.useState("both");

    function getBreedingDogs() {
        setLoading(true);
        axios.single({
            method: 'get',
            url: "/api/dogs/breedingdogs/" + params.breedid,
            responseType: 'json',
        }).then((res: any) => {
            setDogs(res.data);

            let tempDogs = res.data;
            if (publishTypeFilter != "both") {
                tempDogs = res.data.filter((dog: any) => {
                    return dog.PUBLISHED_PUBLIC == publishTypeFilter;
                });
            }
            if (sexFilter != "both") {
                tempDogs = tempDogs.filter((dog: any) => {
                    return dog.SEX == sexFilter;
                });
            }
            setFilteredDogs(tempDogs);
        }).catch((err: any) => {
            console.log(err);
        }).finally(() => {
            setLoading(false);
        });
    }

    function calculateAge(birthdate: string) {
        const birth = new Date(birthdate);
        const now = new Date();
        const diff = now.getTime() - birth.getTime();
        const age = new Date(diff);
        return Math.abs(age.getUTCFullYear() - 1970);
    }

    useEffect(() => {
        getBreedingDogs();
    }, []);

    useEffect(() => {
        let tempDogs = dogs;
        if (publishTypeFilter != "both") {
            tempDogs = dogs.filter((dog: any) => {
                if (dog.PUBLISHED_PUBLIC == "1") return true;
                return dog.PUBLISHED_PUBLIC == publishTypeFilter;
            });
        }
        if (sexFilter != "both") {
            tempDogs = tempDogs.filter((dog: any) => {
                return dog.SEX == sexFilter;
            });
        }
        setFilteredDogs(tempDogs);
    }, [sexFilter, publishTypeFilter]);
    
    return (
        <div className={styles.breedingdogs}>
            <h1>{t('breedingdogs.title')}</h1>
            <hr/>
                <div
                    className={styles.dropdownfilters}
                >
                    <div className={styles.filter}>
                        <label>{t('breedingdogs.filters.sex.title')}</label>
                        <Form.Control
                            as="select"
                            value={sexFilter}
                            onChange={(e: any) => setSexFilter(e.target.value)}
                        >
                            <option value="both">{t('breedingdogs.filters.values.both')}</option>
                            <option value="male">{t('breedingdogs.filters.values.male')}</option>
                            <option value="female">{t('breedingdogs.filters.values.female')}</option>
                        </Form.Control>
                    </div>
                    {params.breedid == "145" ?
                        <div className={styles.filter}>
                            <label>{t('breedingdogs.filters.publishtype.title')}</label>
                            <Form.Control
                                as="select"
                                value={publishTypeFilter}
                                onChange={(e: any) => setPublishTypeFilter(e.target.value)}
                            >
                                <option value="both">{t('breedingdogs.filters.values.both')}</option>
                                <option value="leash">{t('breedingdogs.filters.values.leash')}</option>
                                <option value="loose">{t('breedingdogs.filters.values.loose')}</option>
                            </Form.Control>
                        </div>
                    : null}
                </div>
            <hr/>
            {loading ? 
                <p>{t('breedingdogs.loading')}</p>
            : null}
            {filteredDogs.length > 0 ?
                <div
                    className={styles.tablecontainer}
                >
                    <PublicTable
                        headers={[
                            ...Object.keys(filteredDogs[0]).map((key: string) => {
                                // Skip some columns
                                if (key == "PUBLISHED_PUBLIC") return null;

                                // Custom display for some columns
                                if (key == "DATE_BIRTH") {
                                    return {
                                        label: t("breedingpageconfig.publiccolumns.titles." + key),
                                        field: key,
                                        override: (data: any) => calculateAge(data.DATE_BIRTH)
                                    };
                                }
                                if (key == "OWNER_NAME") {
                                    return {
                                        label: t("breedingpageconfig.publiccolumns.titles." + key),
                                        field: key,
                                        override: (data: any) => data.OWNER_NAME == ", " ? "" : data.OWNER_NAME
                                    };
                                }
                                if (key == "SEX") {
                                    return {
                                        label: t("breedingpageconfig.publiccolumns.titles." + key),
                                        field: key,
                                        override: (data: any) => t("breedingdogs.filters.values." + data.SEX + "single")
                                    };
                                }
                                if (key == "PRIZED_OFFSPRING_PERCENTAGE") {
                                    return {
                                        label: t("breedingpageconfig.publiccolumns.titles." + key),
                                        field: key,
                                        override: (data: any) => {
                                            if (data.PRIZED_OFFSPRING_PERCENTAGE == null) return "0%";
                                            // Round to 2 decimals
                                            let percentage = Math.round(data.PRIZED_OFFSPRING_PERCENTAGE * 100) / 100;
                                            return percentage + "%";
                                        }
                                    };
                                }
                                if (key == "PROS_HD_RONTGET_AVK") {
                                    return {
                                        label: t("breedingpageconfig.publiccolumns.titles." + key),
                                        field: key,
                                        override: (data: any) => {
                                            if (data.PROS_HD_RONTGET_AVK == null) return "0%";
                                            // Round to 2 decimals
                                            let percentage = Math.round(data.PROS_HD_RONTGET_AVK * 100) / 100;
                                            return percentage + "%";
                                        }
                                    };
                                }
                                if (key == "HD_SIKKERHET") {
                                    return {
                                        label: t("breedingpageconfig.publiccolumns.titles." + key),
                                        field: key,
                                        override: (data: any) => {
                                            return Math.round(data.HD_SIKKERHET * 100) / 100;
                                        }
                                    };
                                }
                                return { label: t("breedingpageconfig.publiccolumns.titles." + key), field: key };
                            }).filter((header: any) => header != null)
                        ]}
                        data={filteredDogs}
                    ></PublicTable>
                </div>
            : null}
            {filteredDogs.length == 0 && !loading ?
                <p>{t('breedingdogs.noresults')}</p>
            : null}
        </div>
    );
}

class BreedingDogsProps {
    
}

export default BreedingDogs;